import Home from './Components/Home/Home'; // 1. Import your existing Home component
import Dashboard from './Components/Dashboard/Dashboard';

function App() {
  return (
      <div className="App">
        <Home />
      </div>
  );
}

export default App;